import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function MapCampaign() {
    return (
        <div className='container max-w-7xl mx-auto'>
            <div className="h-fit overflow-hidden rounded-[15px] mt-5">
                <LazyLoadImage className="w-full h-fit object-cover" src="https://s3-alpha-sig.figma.com/img/2383/21b2/467b2473a6c17ecca6daa3aca6f2cd01?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=ipnkHfuABISIOuubOjoYpoKiMlfnRkrV0p3z2EopwyuyOS5tG79R1bec062b-0UFd4Fqr~9SSP057GYIU7ne5YGayXbThg6pFBkfW9xxPerN1ye~LUVQKZUk4MJ8mTgsU0sfrcshD0Sp81LaDhdt04KZUhNlXczS5zCkTL6hZlIAblcGkk08wRRVv0KKOCp~L-mZ39zeCZBEFeZ35TMtGy7j-ScZj0t71GWcaHZ92FOu1OyRElth5QWHNj1GEzHLK6sS7Ls-YKXRAN13VjcMVUacx~bI08ju-g4sUZLczCQW6z2fMi1GfgJMPnGu~11~tFaGFX6A0CCK673oHZF1yw__" alt="Your Image" />
            </div>
        </div>
    )
}

export default MapCampaign